import $ from 'jquery';
import template from '../libs/templates/clip-list-item.hbs';
import ClipList from '../libs/clip-list';
import inherit from '../libs/core/inherit';
import defaultListConfigs from '../libs/clip-list/default-configs';

export const MORE = 'more';
export const FOLD = 'fold';
export const EXPAND = 'expand';

export const defaultOptions = $.extend({}, defaultListConfigs, {
  template: $.templates(template),
  expender: '',
  viewCount: 5,
  maxCount: 25
});

/**
 * ClipList를 통검 펼쳐보기 공통 모듈인 SF.extend와 결합
 *
 * @see {@link http://hehet.dev.daum.net/scripts/modules/extend/index.html}
 *
 * @param opts
 * @constructor
 * @augments ClipList
 */
function ClipListExtend(opts) {
  ClipList.call(this, opts);
  const {expender, container, viewCount, maxCount, template} = opts;

  const self = this;
  this.maxCount = maxCount || -1;
  this.viewCount = viewCount;
  this.page = 1;
  this.$template = template;
  this.isEnd = false;

  this.extendModule = new SF.extend({
    expender: expender,
    container: container,
    viewCount: viewCount,
    source(resolve) {
      self.emit(MORE, (clip) => self.renderToClipList(clip, resolve));
    },
    onFold(e) {
      self.page = 1;
      self.emit(FOLD, $.extend(e, {detail: {page: self.page}}));
    },
    onExpand(e) {
      self.page++;
      self.emit(EXPAND, $.extend(e, {detail: {page: self.page}}));
    }
  });
}

$.extend(ClipListExtend, {
  events: $.extend({}, ClipList.events, {MORE, FOLD, EXPAND}),
  create(options) {
    const opts = $.extend({}, defaultOptions, options);
    return new ClipListExtend(opts);
  }
});

inherit(ClipListExtend, ClipList, {
  renderToClipList(clips, add) {
    const responseLength = clips.length;
    this.length += responseLength;
    this.isEnd = this.isEnd || this.length >= this.maxCount;
    add(this.renderList(clips), this.isEnd);
  },
  renderList(templateData) {
    const td = templateData.map ? templateData : [templateData];
    return td.map((data) => this.$template.render(data)).join('');
  }
});

export default ClipListExtend;


/** WEBPACK FOOTER **
 ** ./src/VO2/tot/clip-list.js
 **/